import styled from 'styled-components';
import LoadingSpinner from '@paradigm/design-system/src/components/LoadingSpinner';
import BaseModal from '@paradigm/design-system/src/components/Modal';

export default function LoadingModal() {
  return (
    <CenteredModal width="unset" isOpen isFullScreenMobile={false}>
      <div css="padding: 16px;">
        <LoadingSpinner size={50} />
      </div>
    </CenteredModal>
  );
}

const CenteredModal = styled(BaseModal)`
  position: absolute;
  top: 20%;
  left: 50%;
  transform: translate(-50%, 0) !important;
`;
